import { connect } from 'react-redux';
import moment from 'moment';
import OptionSummary from './OptionSummary';

const mapStateToProps = ({ estimateBuilder }, ownProps) => {
  const { uiState, entities } = estimateBuilder;
  const { itemProduct, estimatedShipDate } = entities.items.byId[ownProps.itemId];
  const {
    attributes, choices, brand, isValid, isStockProduct,
  } = itemProduct;
  const { isLockedOrOrdered } = entities.estimates.byId[uiState.selectedEstimate];
  const { isMandi } = entities.estimates.byId[uiState.selectedEstimate].attributes || false;
  const expandedOptions = choices.filter(choice =>
    !attributes
      .find(attribute => attribute.name.toLowerCase() === choice.optionName.toLowerCase()));
  const isOpen = uiState.expandedItems.indexOf(ownProps.itemId) !== -1;

  const hasWidthAndHeight =
    (attributes.findIndex(attribute => attribute.name === 'Width') >= 0 && attributes.findIndex(attribute => attribute.name === 'Height') >= 0);

  const estimateShipDate = moment.utc(estimatedShipDate || moment().add(20, 'days'))
    .format(window.globals.siteId === 3 ? 'M/DD/YYYY' : 'MMM D');
  const estimateLabel = window.globals.siteId === 3 ? 'Est. Shipping' : 'Est. Delivery';

  return {
    attributes,
    expandedOptions,
    brand,
    isOpen,
    hasWidthAndHeight,
    isValid,
    isLockedOrOrdered,
    isMandi,
    isStockProduct,
    estimateShipDate,
    estimateLabel,
  };
};

export default connect(mapStateToProps)(OptionSummary);
